import { getMessages } from '../../../../../../../store/constants';
import {
    CLASS_ASIDE_PANEL_ACTIONS_BUTTON_CONTAINER
} from '../../../../asidePanel/components/AsidePanelActionsButton/constants';

export const DELETE_BUTTON_TITLE = getMessages().getText('board_settings.actions.delete');
export const CLASS_DELETE_BUTTON = CLASS_ASIDE_PANEL_ACTIONS_BUTTON_CONTAINER + '--delete';
